module.exports = __webpack_public_path__ + "img/thumbnail_CollaredPeccary_j_normal.7929a0aa.png";